"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAgChartDefinition = exports.isExternalChartDefinition = void 0;
const isExternalChartDefinition = (chartDefinition) => {
    return chartDefinition && 'Data' in chartDefinition;
};
exports.isExternalChartDefinition = isExternalChartDefinition;
const isAgChartDefinition = (chartDefinition) => {
    return chartDefinition && 'Model' in chartDefinition;
};
exports.isAgChartDefinition = isAgChartDefinition;
